import { IProductItem } from "interfaces";
import { convertCurrency, currencySymbol, formatNumber } from "utills/helpers";

interface ProductTableProps {
  data?: IProductItem[];
  pageSize: number;
  currentPage: number;
  orderCurrency: string;
  rate: number;
}

export const ProductTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  orderCurrency = "",
  rate,
}: ProductTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Ticket name
              </th>
              <th scope="col" className="th">
                Quantity
              </th>
              <th scope="col" className="th">
                Price
              </th>
              <th scope="col" className="th">
                Discount amount
              </th>
              <th scope="col" className="th">
                Total
              </th>
              <th scope="col" className="th">
                Used code
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IProductItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td">{item.product_name_en}</td>
                <td className="td" style={{ wordWrap: "break-word" }}>
                  {formatNumber(item.quantity ?? 0)}
                </td>
                <td className="td">
                  {currencySymbol()}{" "}
                  {convertCurrency(
                    item.subtotal ?? 0,
                    orderCurrency ?? "",
                    rate
                  )}
                </td>
                <td className="td">
                  {currencySymbol()}{" "}
                  {convertCurrency(
                    item.discount_amount ?? 0,
                    orderCurrency ?? "",
                    rate
                  )}
                </td>
                <td className="td">
                  {currencySymbol()}{" "}
                  {convertCurrency(
                    item.grand_total ?? 0,
                    orderCurrency ?? "",
                    rate
                  )}
                </td>
                <td className="td">{item.coupon}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
